import { UserGroupIcon } from '@heroicons/react/24/outline'
import Footer from './Footer';
import Topbar from './Topbar';

const features = [
  // {
  //   name: 'Have an Idea?',
  //   description:
  //     'Have an idea that you\'re working on, but only getting nights and weekends to do it?  We have a solution baked into our working model.',
  //   href: '/registration',
  //   icon: LightBulbIcon,
  //   calltoaction: 'Submit your idea!'
  // },
  // {
  //   name: 'Need an Idea?',
  //   description:
  //     'It\'s okay if you don\'t have an idea we have a few.  We are always looking for people to help us bring ideas to life.',
  //   href: '/inspiration',
  //   icon: Cog6ToothIcon,
  //   calltoaction: 'Get Inspired!'
  // },
  {
    name: 'Join the team, stay for the Community',
    description:
      'No matter where you are in your career where you go next is very important to us',
    href: '/JoinTeam',
    icon: UserGroupIcon,
    calltoaction: 'Join the team!'
  },
]

export default function Community() {
  return (
    <div> 
        <Topbar />
        <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-pretty text-2xl font-semibold tracking-tight text-gray-900 sm:text-3xl">
            Build with our community!<br/>
            Submit your idea.<br/>
            Join the team. . .
          </h2>
          <p className="mt-6 text-lg/8 text-gray-600">
            We are engineers, designers, artists, thinkers and makers at heart.  We care about the work we do and the people we do it for.<br/><br/> 
            The world of work is changing and we are changing with it, come find out how we work and why you will like working here.
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
            {features.map((feature) => (
              <div key={feature.name} className="flex flex-col">
                <dt className="text-base/7 font-semibold text-gray-900">
                  <div className="mb-6 flex size-10 items-center justify-center rounded-lg bg-gray-600">
                    <feature.icon aria-hidden="true" className="size-6 text-white" />
                  </div>
                  {feature.name}
                </dt>
                <dd className="mt-1 flex flex-auto flex-col text-base/7 text-gray-600">
                  <p className="flex-auto">{feature.description}</p>
                  <p className="mt-6">
                    <a href={feature.href} className="text-sm/6 font-semibold text-gray-600 hover:text-gray-400">
                       <span aria-hidden="true">{feature.calltoaction} →</span>
                    </a>
                  </p>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
        <Footer />
    </div>
  )
}